module.exports = __webpack_public_path__ + "img/Bangladesh.ce1096aa.svg";